<div class="view-component">
    <div class="toolbar">
        <app-tool-bar [instanceDescription]="entityDesc" [instanceName]="table_name" [dataTable]="dynamicTable" [service]="_dynaServices" [userId]="userId" ></app-tool-bar>
    </div>
    <div class="view-component-body">
     
         <div class="grid-filter" [hidden]="!_dynaServices.gridMode" [@enterAnimation] >
            <input nz-input (keyup)="updateFilter($event)" [placeholder]="filtroStr">
        </div>

        <div class="table-elevation"  [hidden]="!_dynaServices.gridMode" [@enterAnimation] >
            <ngx-datatable #dynamicTable class="material striped server-scrolling" name="datatable-body"
                [rows]="_dynaServices.rows" 
                [headerHeight]="_dynaServices.headerHeight"
                [rowHeight]="_dynaServices.rowHeight"
                [messages]="{'emptyMessage':'Não encontrado dados.','totalMessage': 'total'}"
                [reorderable]="true"
                [swapColumns]="false"
                [loadingIndicator]="_dynaServices.loadingIndicator"
                [sortType]="'multi'"
                [columns]="_dynaServices.dynaColumns"
                [targetMarkerTemplate]="targetMarkerTemplate"
                [scrollbarH] = "true"
                [scrollbarV]="true"
                [selected]="selected"
                [selectionType]="'multi'"
                (activate)="eventGrid($event)"
                (scroll)="_dynaServices.onScroll(0,$event.offsetY)"
                (reorder)="onReoder($event.column,$event.newValue,$event.prevValue)"
                (resize)="onResize($event.column,$event.newValue)"
                [footerHeight]="50"
                (tableContextmenu)="onTableContextMenu($event)">
                

                <!--ngx-datatable-column  *ngFor="let col of _dynaServices.enabledColumns" [name]="col.COLUMNDESC" [prop]="col.COLUMNNAME" [width]="col.COLWIDTH == null || col.COLWIDTH == 0 ?150 : col.COLWIDTH ">
                </!--ngx-datatable-column-->
            </ngx-datatable>
            <!--[columns]="_dynaServices.dynaColumns"
                -->
            <ng-template #targetMarkerTemplate let-class="class">
                <div [ngClass]="class">
                  <div class="icon datatable-icon-down"></div>
                  <div class="icon datatable-icon-up"></div>
                </div>
              </ng-template>
             
        </div>
        <div class="formview">
            <app-form-view  [@enterAnimation]  (submitted)="formSubmitted($event)" #formView [service]="_dynaServices"  [row]="_dynaServices.selectedRow[0]" [arrayColumnsDef]="_dynaServices.displayedColumns" [rowTemplate]="_dynaServices.enabledColumns" *ngIf="!_dynaServices.gridMode" [tabs]="tabs" [fatherFilterExpression]="fatherFilterExpression"> </app-form-view>
        </div>
    </div>
</div>
